import { api } from '@/lib/api/client'
import { toNotification } from '@/features/notifications/api/get-notifications'
import type {
  Notification,
  NotificationResponse,
} from '@/features/notifications/types/notification'

/** `PUT /notifications/{notification}/read` marks one notification read. */
export async function markNotificationRead(id: number): Promise<Notification> {
  const { data } = await api.put<{ data: NotificationResponse }>(`/notifications/${id}/read`)

  return toNotification(data.data)
}
